import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { useAppContext } from "../context/appContext";

import { DashboardPage } from "../pages/DashboardPage";
import { NotFoundPage } from "../pages/NotFoundPage";
// import { ProfilePage } from "../pages/ProfiePage";
import { LoginPage } from "../pages/LoginPage";
import ProtectedRoute from "./ProtectedRoute";
import { ProfileDetailsPage } from "../pages/ProfileDetailsPage";
import { AddDecisionPage } from "../pages/AddDecisionPage";
import { DecisionPage } from "../pages/DecisionPage";
import { SearchPage } from "../pages/SearchPage";
import { UnitPage } from "../pages/UnitPage";
import { AddUnitPage } from "../pages/AddUnitPage";
import { UnitsPage } from "../pages/UnitsPage";
import { AdminPage } from "../pages/AdminPage";
import { CalendarPage } from "../pages/CalendarPage";
import { MeetingsPage } from "../pages/MeetingsPage";
import { MeetingPage } from "../pages/MeetingPage";
import { AddMeetingPage } from "../pages/AddMeetingPage";
import { AccountSettingsPage } from "../pages/AccountSettingsPage";
import { PeoplePage } from "../pages/PeoplePage";
import { AcceptInvitationPage } from "../pages/AcceptInvitationPage";
import { OrganizationsPage } from "../pages/OrganizationsPage";
import useCurrentUser from "../hooks/useCurrentUser";

export const LocationDisplay = () => {
	const location = useLocation();
	console.log("location: ", location);

	return <div data-testid="location-display">{location.pathname}</div>;
};

/** The landing page of the logged-in user, once their role is known. */
function HomeRedirect() {
	const { isLoading, homePath } = useCurrentUser();
	return isLoading ? null : <Navigate to={homePath} replace />;
}

export default function MainRoutes() {
	const { items } = useAppContext();
	const { isUserLogin } = items;
	return (
		<Routes>
			<Route path="/" element={isUserLogin ? <HomeRedirect /> : <LoginPage />} />
			{/* <Route
				path="/dashboard"
				element={
					<ProtectedRoute>
						<DashboardPage />
					</ProtectedRoute>
				}
			/> */}
			<Route
				path="/calendar"
				element={
					<ProtectedRoute allow="unitWork">
						<CalendarPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/decisions"
				element={
					<ProtectedRoute allow="viewDecisions">
						<DashboardPage />
					</ProtectedRoute>
				}
			></Route>
			<Route
				path="/decisions/:id"
				element={
					<ProtectedRoute allow="viewOrganization">
						<DecisionPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/units"
				element={
					<ProtectedRoute allow="viewOrganization">
						<UnitsPage />
					</ProtectedRoute>
				}
			>
				<Route
					path=":id"
					element={
						<ProtectedRoute allow="viewOrganization">
							<UnitPage />
						</ProtectedRoute>
					}
				/>
			</Route>
			<Route
				path="/add-unit"
				element={
					<ProtectedRoute allow="createUnits">
						<AddUnitPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/meetings"
				element={
					<ProtectedRoute allow="unitWork">
						<MeetingsPage />
					</ProtectedRoute>
				}
			>
				<Route
					path=":id"
					element={
						<ProtectedRoute allow="unitWork">
							<MeetingPage />
						</ProtectedRoute>
					}
				/>
			</Route>
			<Route
				path="/add-meeting"
				element={
					<ProtectedRoute allow="unitWork">
						<AddMeetingPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/organizations"
				element={
					<ProtectedRoute allow="manageOrganizations">
						<OrganizationsPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/people"
				element={
					<ProtectedRoute>
						<PeoplePage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/search"
				element={
					<ProtectedRoute search={true} allow="viewDecisions">
						<SearchPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/add-decision"
				element={
					<ProtectedRoute allow="createDecisions">
						<AddDecisionPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/profile"
				element={
					<ProtectedRoute>
						<Navigate to="/profile/details" replace />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/profile/details"
				element={
					<ProtectedRoute>
						<ProfileDetailsPage title="Personal data" />
					</ProtectedRoute>
				}
				title="Details"
			/>
			<Route
				path="/profile/settings"
				element={
					<ProtectedRoute>
						<AccountSettingsPage title="Account settings" />
					</ProtectedRoute>
				}
				title="Details"
			/>
			<Route
				path="/admin-panel"
				element={
					<ProtectedRoute allow="adminPanel">
						<AdminPage />
					</ProtectedRoute>
				}
			/>
			{/* Link in invitation emails; works with or without being logged in */}
			<Route path="/invitation/:token" element={<AcceptInvitationPage />} />
			<Route path="/login" element={!isUserLogin ? <LoginPage /> : <HomeRedirect />} />
			<Route
				path="/404"
				element={
					<ProtectedRoute>
						<NotFoundPage />
					</ProtectedRoute>
				}
			/>
			<Route path="*" element={<Navigate to="/404" replace />} />
		</Routes>
	);
}
